// extracted by mini-css-extract-plugin
export default {"loading":"loading-2lH9Z","rotate":"rotate-3cAiD","loadingSmall":"loadingSmall-2m3gv","loadingMedium":"loadingMedium-2t9aE","loadingBig":"loadingBig-13nXd"};